<template>
  <div class='info'>
    <div class='button'>
      <el-button @click="onAdd" type="primary">+ 添加发票信息</el-button>
    </div>
    <div class="invoice" v-for="(item, index) in invoice_list" :key='index'>
      <div>
        <el-button @click="onModify(item)" type="primary" class="btn">修 改</el-button>
        <el-button @click="onDelete(item.invoiceId)" type="primary" class="btn">删 除</el-button>
      </div>
      <p><span><strong>{{item.invoiceType===2?'增值税发票':'普通发票'}}</strong></span><span class="left"><div></div></span></p>
      <p><span><div>发票抬头：</div></span><span class="left"><div>{{item.invoiceTitle}}</div></span></p>
      <p v-show="item.type===1 || item.invoiceType===2"><span><div>纳税人识别号：</div></span><span class="left"><div>{{item.creditCode}}</div></span></p>
      <p v-show="item.invoiceType===2"><span><div>注册地址：</div></span><span class="left"><div>{{item.registerAddress}}</div></span></p>
      <p v-show="item.invoiceType===2"><span><div>注册电话：</div></span><span class="left"><div>{{item.registerTel}}</div></span></p>
      <p v-show="item.invoiceType===2"><span><div>开户银行：</div></span><span class="left"><div>{{item.bankName}}</div></span></p>
      <p v-show="item.invoiceType===2"><span><div>银行账号：</div></span><span class="left"><div>{{item.bankAccount}}</div></span></p>
      <p><span><div>收票人手机号：</div></span><span class="left"><div>{{item.receiverMobile === undefined || item.receiverMobile === '' ?'--':item.receiverMobile}}</div></span></p>
    </div>
    <div class="pageIndex fy main-pagination" v-if="totalPage > 9">
      <el-pagination
        @current-change="handlePageChange"
        layout="prev, pager, next"
        :total="totalPage">
      </el-pagination>
    </div>
    <br/>
    <br/>
    <el-dialog
      :visible.sync="diagVisible"
      width="40%">
      <div>
      <el-tabs v-model="activeName">
        <el-tab-pane label="普通发票" name="normal" class="invoiceTab">
          <el-form ref="normalForm" :model="normalForm" :rules="rules" label-width="106px">
            <el-form-item label="发票类型" prop="type">
              <el-radio-group v-model="normalForm.type" @change="onChange">
                <el-radio label="1">企业</el-radio>
                <el-radio label="2">个人</el-radio>
              </el-radio-group>
            </el-form-item>
            <el-form-item label="发票抬头" prop="title">
              <el-input v-model="normalForm.title" maxlength="50"></el-input>
            </el-form-item>
            <el-form-item label="纳税人识别号" prop="id" v-show="normalForm.type==1">
              <el-input v-model="normalForm.id" maxlength="50"></el-input>
            </el-form-item>
            <el-form-item label="收票人手机号" prop="phone">
              <el-input v-model="normalForm.phone" maxlength="11"></el-input>
            </el-form-item>
          </el-form>
          <el-button type="primary" style="margin-left: 150px;" @click="onSubmit('normalForm')" :disabled="disabled">保存</el-button>
        </el-tab-pane>
        <el-tab-pane label="增值税发票" name="VAT">
          <el-form ref="vatForm" :model="vatForm" :rules="rules" label-width="106px">
            <el-form-item label="发票抬头" prop="title">
              <el-input v-model="vatForm.title"  maxlength="50"></el-input>
            </el-form-item>
            <el-form-item label="纳税人识别号" prop="id">
              <el-input v-model="vatForm.id"  maxlength="50"></el-input>
            </el-form-item>
            <el-form-item label="注册地址" prop="adr">
              <el-input v-model="vatForm.adr"  maxlength="50"></el-input>
            </el-form-item>
            <el-form-item label="注册电话" prop="tel">
              <el-input v-model="vatForm.tel"  maxlength="50"></el-input>
            </el-form-item>
            <el-form-item label="开户银行" prop="bank">
              <el-input v-model="vatForm.bank"  maxlength="50"></el-input>
            </el-form-item>
            <el-form-item label="银行账号" prop="num">
              <el-input v-model="vatForm.num"  maxlength="50"></el-input>
            </el-form-item>
            <el-form-item label="收票人手机号" prop="phone">
              <el-input v-model="vatForm.phone" maxlength="11"></el-input>
            </el-form-item>
          </el-form>
          <el-button type="primary" style="margin-left: 150px;" @click="onSubmit" :disabled="disabled">保存</el-button>
        </el-tab-pane>
      </el-tabs>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { mapMutations, mapGetters } from 'vuex';

export default {
  data() {
    const validateMobile = (rule, value, callback) => {
      if (!value) {
        this.disabled = false;
        return;
      }
      if (!/^1[3|4|5|6|7|8|9][0-9]\d{8}$/.test(value)) {
        this.disabled = true;
        callback(new Error('手机号错误!'));
      } else {
        this.disabled = false;
        callback();
      }
    };
    const isRequire = (rule, value, callback) => {
      if (!value) {
        return;
      }
      if (value === "") {
        callback(new Error('此项必填!'));
      } else {
        callback();
      }
    };

    return {
      invoiceId: undefined,
      disabled: false,
      add: '',
      invoice_type: 'normal',
      diagVisible: false,
      activeName: "normal",
      pageIndex: 1,
      invoice_list: [],
      totalPage: 0,
      normalForm: {
        type: '1',
        title: '',
        id: '',
        phone: '',
      },
      rules: {
        title: [
          { required: false, message: '发票抬头', trigger: 'blur' },
        ],
        id: [
          { validator: isRequire, max: 50, message: '长度须小于50字', trigger: 'blur' }
        ],
        phone: [
          { validator: validateMobile, required: true, trigger: 'blur' },
        ],
      },
      vatForm: {
        title: '',
        id: '',
        adr: '',
        tel: '',
        bank: '',
        num: '',
        phone: '',
      },
      rules: {
        title: [
          { validator: isRequire, required: true, message: '请输入发票抬头', trigger: 'blur' },
          { max: 50, message: '长度小于30字', trigger: 'blur' }
        ],
        id: [
          { validator: isRequire, required: true, message: '请输入纳税人识别号', trigger: 'blur' },
          { max: 50, message: '长度小于20字', trigger: 'blur' }
        ],
        phone: [
          { validator: validateMobile, trigger: 'blur' },
        ],
        bank: [
          { validator: isRequire, required: true, message: '请输入开户银行', trigger: 'blur' },
          { max: 50, message: '长度须小于30字', trigger: 'blur' }
        ],
        tel: [
          { validator: isRequire, required: true, message: '请输入注册电话', trigger: 'blur' },
          { max: 50, message: '长度须小于20字', trigger: 'blur' }
        ],
        num: [
          { validator: isRequire, required: true, message: '请输入银行账号', trigger: 'blur' },
          { max: 50, message: '长度须小于20字', trigger: 'blur' }
        ],
        adr: [
          { validator: isRequire, required: true, message: '请输入注册地址', trigger: 'blur' },
          { max: 50, message: '长度须小于20字', trigger: 'blur' }
        ],
      },
    };
  },
  methods: {
    ...mapMutations(['change_userTab']),
    onChange(){
      this.normalForm.title = this.normalForm.type == 1 ? this.user.bindCorpInfo.corpName || undefined : this.user.realName;
    },
    onAdd(){
      this.activeName = 'normal'
      this.normalForm.phone = this.user.userMobile;
      this.normalForm.id = undefined;
      this.normalForm.title = this.user.bindCorpInfo.corpName || undefined;
      this.normalForm.type = '1';
      this.vatForm.title = this.user.bindCorpInfo.corpName || undefined;
      this.vatForm.id = undefined;
      this.vatForm.adr = undefined;
      this.vatForm.tel = undefined;
      this.vatForm.bank = undefined;
      this.vatForm.num = undefined;
      this.vatForm.phone = this.user.userMobile;
      this.add = true;
      this.diagVisible = true;
    },
    onModify(e){
      e.invoiceType === 1 ? this.activeName = 'normal' : this.activeName = 'VAT';
      e.type === 1 ? this.normalForm.type = '1' : this.normalForm.type = '2';
      this.normalForm.phone = e.receiverMobile;
      this.normalForm.id = e.creditCode;
      this.normalForm.title = e.invoiceTitle;
      this.vatForm.title = e.invoiceTitle;
      this.vatForm.id = e.creditCode;
      this.vatForm.adr = e.registerAddress;
      this.vatForm.tel = e.registerTel;
      this.vatForm.bank = e.bankName;
      this.vatForm.num = e.bankAccount;
      this.vatForm.phone = e.receiverMobile;
      this.invoiceId = e.invoiceId;
      this.add = false;
      this.diagVisible = true;
    },
    onSubmit(){
      let _this = '';
      this.activeName === 'normal' ? _this = this.normalForm : _this = this.vatForm;
      if(this.add){
        this.$http.post(`${this.URL_PREFIX}/app/added/user/invoice/info`,{
          bankName: _this.bank,
          bankAccount: _this.num,
          createTime: Date.parse( new Date()),
          creditCode: _this.id,
          invoiceTitle: _this.title,
          invoiceType: this.activeName === 'normal' ? 1 : 2,
          type: this.normalForm.type,
          receiverMobile: _this.phone,
          registerAddress: _this.adr,
          registerTel: _this.tel,
        },{
          headers: { token: this.token },
        }).then((res) => {
          if(res.data.resCode == 10000){
            this.$message({
              type: 'success',
              message: '添加成功!'
            });
            this.diagVisible = false;
            this.getList();
          }else{
            this.$message({
              type: 'info',
              message: '缺少必填信息!'
            });
          }
        })
      }else{
        this.$http.post(`${this.URL_PREFIX}/app/modify/user/invoice/info`,{
          bankName: _this.bank,
          bankAccount: _this.num,
          createTime: Date.parse( new Date()),
          creditCode: _this.id,
          invoiceId: this.invoiceId,
          invoiceTitle: _this.title,
          invoiceType: this.activeName === 'normal' ? 1 : 2,
          type: this.normalForm.type,
          receiverMobile: _this.phone,
          registerAddress: _this.adr,
          registerTel: _this.tel,
        },{
          headers: { token: this.token },
        }).then((res) => {
          if(res.data.resCode == 10000){
            this.$message({
              type: 'success',
              message: '修改成功!'
            });
            this.getList();
          }else{
            this.$message({
              type: 'info',
              message: '修改失败，请完善必填信息!'
            });
          }
        })
        this.diagVisible = false;
      }
    },
    onDelete(e){
      this.$confirm('确认删除此发票?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.$http.post(`${this.URL_PREFIX}/app/delete/user/invoice/info`,{
          invoiceId: e,
        },{
          headers: { token: this.token },
        }).then((res) => {
          if(res.data.resCode == 10000){
            this.$message({
              type: 'success',
              message: '删除成功!'
            });
            this.getList();
          }else{
            this.$message({
              type: 'info',
              message: '删除失败!'
            });
          }
        })
      })
    },
    handlePageChange(e){
      this.pageIndex = e;
      this.getList();
    },
    getList(){
      this.$http.post(`${this.URL_PREFIX}/app/get/user/invoice/info/list`,{
        currPage: this.pageIndex,
        pageRows: 10,
      },{
        headers: { token: this.token },
      }).then((res) => {
        if(res.data.resCode == 10000){
          this.totalPage = res.data.resData.pageInfo.total;
          this.invoice_list = res.data.resData.pageList;
        }else{
          alert(res.data.resDesc);
        }
      })
    }
  },
  computed: {
    ...mapGetters(['token', 'user']),
  },
  mounted() {
    this.getList();
  },
};
</script>


<style lang="scss" scoped>
@import '~@scss';

.info{
  background: #fff;
  width: 900px;
  min-height: 500px;
  .button{
    padding: 24px;
  }
  .invoice{
    border-bottom: 1px solid #F2F2F2;
    margin-top: 17px;
    padding-left: 16px;
    margin-bottom: 33px;
    margin-left: 24px;
    padding-bottom: 21px;
    width: 750px;
    strong{
      color: #000;
      font-size: 16px;
      margin-bottom: 14px;
      display: block;
    }
    .btn{
      float: right;
      height: 11px !important;
      margin-left: 20px;
      font-size: 12px;
      padding-bottom: 18px;
      padding-top: -4px;
    }
    p{
      font-size: 15px;
      padding-bottom: -2px;
      span{
        display: inline-block;
        vertical-align: top;
        width: 105px;
        div{
          float: right;
          margin-top: 5px;
        }
      }
      .left{
        display: inline-block;
        width: 405px;
        color: #000;
        div{
          float: left;
          margin-top: 5px;
          width: 405px;
        }
      }
    }
  }
  .pageIndex{
    float: right;
    padding-right: 40px;
  }
}
</style>


// WEBPACK FOOTER //
// src/pages/navigator/personal/components/info/Invoice.vue